import styles from "../styles/components/Header.module.scss";
import { format } from "date-fns";
import { nl } from "date-fns/locale";

import { useState } from "react";
import { Divider } from "@qastanfit/qastan-ui"

export default function Header({}){
    const [enabledDarkmode, setenabledDarkmode] = useState(false);
    
    const toggleNightmode = () => {
        const html = document.getElementsByTagName('html')[0];
        if(html.dataset.theme !== "dark-mode"){
            setenabledDarkmode(true)
            html.dataset.theme = "dark-mode";
        }
        else {
            setenabledDarkmode(false)
            html.dataset.theme = ""
        }
    }

    return (
        <div className={styles.header}>
            <button onClick={()=>{toggleNightmode()}} className={styles.nightmode_button}>
                {enabledDarkmode === false ?
                    <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path></svg>
                :
                    <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line></svg>  
                }
            </button>

            <Divider styling={{margin:"0 1rem", height:"60%", backgroundColor:"#C2C9D1"}} orientation="vertical"/>

            <p className={styles.today}>
                <span className={styles.icon}><svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.4444 2.55566H2.55556C1.69645 2.55566 1 3.25211 1 4.11122V15.0001C1 15.8592 1.69645 16.5557 2.55556 16.5557H13.4444C14.3036 16.5557 15 15.8592 15 15.0001V4.11122C15 3.25211 14.3036 2.55566 13.4444 2.55566Z" stroke="#8E8E8E" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/><path d="M11.1113 1V4.11111" stroke="#8E8E8E" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/><path d="M4.88867 1V4.11111" stroke="#8E8E8E" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/><path d="M1 7.22217H15" stroke="#8E8E8E" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/></svg></span>
                {format(new Date(), 'EE, d MMM yyyy', {locale:nl})}
            </p>
            
        </div>
    )
}